import './CourseInformation.css'
import { H2, H4, Section } from '../../../components/text'
import { ControlSVG } from '../../../components/figure'
import { ButtonIcon } from '../../../components/buttons'
import { BoxFlex } from '../../../components/boxes'
import { withRouter } from 'react-router-dom'
const CourseInformation = ({
  course,
  description,
  type,
  history,
  didYouKnow,
}) => {
  const text =
    type === 'English'
      ? 'estoy interesado en los cursos de inglés'
      : didYouKnow
      ? 'estoy interesado en los cursos de ajedrez'
      : 'estoy interesado en los cursos de programación'
  return (
    <>
      <div className="CourseInformation">
        <ColorLine />
        <br />
        <div className="CourseInformation__icon">
          <ButtonIcon icon="chevron-left" onClick={() => history.goBack()} />
        </div>
        <H2 fontSize="3rem" color={course.color} textAlign="end" margin="15px">
          {course.name}
        </H2>
        {type === 'English' ? (
          <InformationEnglish
            course={course}
            description={description}
            type={type}
          />
        ) : (
          <InformationProgramming
            course={course}
            description={description}
            didYouKnow={didYouKnow}
          />
        )}
        <br />
        <br />
      </div>
      <div className="CourseInformation__btnContainer">
        <div className="CourseInformation__text">
          <Section fontSize="2rem" textAlign="center" color="var(--purple)">
            {`El aprendizaje ${
              type === 'English'
                ? 'del inglés'
                : didYouKnow
                ? 'del ajedrez'
                : 'de la programación'
            }, a una edad temprana será la mejor decisión que podrás tomar para el
            desarrollo de tu hij@.`}
          </Section>
          <Section fontSize="2rem" textAlign="center" color="var(--purple)">
            {
              '¡Da ese primer paso con <strong>Capacita Global Internacional</strong>!'
            }
          </Section>
        </div>
        <a
          href={`https://wa.me/591${
            type === 'English' ? '62388663' : '68065042'
          }?text=Hola%20Capacita%20Global%20${
            text ? text.replace(' ', '%20') : ''
          }`}
          target="_blank"
          rel="noopener noreferrer"
        >
          <img
            src="https://res.cloudinary.com/pataformacgi/image/upload/v1655472636/assets/Group_2288_ch20gm_hr4zap.png"
            alt=""
          />
        </a>
      </div>

      <div className="EnglishInformation__footer">
        <CardGreen icon="star">
          Proveemos calidad educativa en un entorno creativo, seguro y divertido
          para que puedan aprender de la mejor manera.
        </CardGreen>
        <CardGreen icon="trophy">
          Estándares de calidad y profesores calificados en pedagogía
          {type === 'English'
            ? ' e idiomas que seguirán de cerca el aprendizaje.'
            : ' para el buen aprendizaje de los niños'}
        </CardGreen>
        <CardGreen icon={didYouKnow ? 'brain' : 'laptop'}>
          {didYouKnow
            ? 'El ajedrez ayuda a desarrollar el cerebro de tu pequeño/a de forma maravillosa'
            : 'Contamos con nuestra propia plataforma para garantizar nuestra calidad apoyada con clases 100% virtuales.'}
        </CardGreen>
      </div>
      <div
        style={{
          boxShadow: '0 0 10px rgba(0, 0, 0, 0.5)',
          padding: '30px 10px',
          marginBottom: '50px',
        }}
      >
        <H2 color="var(--orange2)" fontSize="3rem" textAlign="center">
          ¡¡¡ ADQUIÉRELO YA !!!
        </H2>
        <H4 color="var(--purple)" textAlign="center" fontSize="2rem">
          Pregunta por nuestros precios especiales
        </H4>
        <BoxFlex>
          <a
            href={`https://wa.me/591${
              type === 'English'
                ? '62388663'
                : didYouKnow
                ? '62397333'
                : '68065042'
            }?text=Hola%20Capacita%20Global%20${
              text ? text.replace(' ', '%20') : ''
            }`}
            target="_blank"
            rel="noopener noreferrer"
            className="CourseInformation__btn green"
          >
            <i className="fab fa-whatsapp"></i> <span>Vía WhatsApp</span>
          </a>
          <a
            href="https://www.facebook.com/CapcitaGlobal"
            target="_blank"
            rel="noopener noreferrer"
            className="CourseInformation__btn blue"
          >
            <i className="fab fa-facebook-messenger"></i>{' '}
            <span>Vía Messenger</span>
          </a>
        </BoxFlex>
      </div>
    </>
  )
}
function InformationProgramming({ course, description, didYouKnow }) {
  return (
    <>
      <div className="CourseInformation__flex" style={{ marginBottom: '40px' }}>
        <div className="CourseInformation__image">
          <img src={course.image} alt="" />
        </div>
        <div className="CourseInformation__section">
          <H2 color={course.color2} textAlign="center" margin="15px">
            {course.section.title}
          </H2>
          <ControlSVG
            color={course.color}
            widthText="75%"
            width="500px"
            figure={course.section.figure}
          >
            <Section margin="45px 0 0" fontSize="2rem" color={course.color}>
              {course.section.content}
            </Section>
          </ControlSVG>
        </div>
      </div>
      <ControlSVG
        color={course.color}
        widthText="85%"
        width="800px"
        figure={description[0].figure}
      >
        <div className="CourseInformation__flex3">
          <Section fontSize="2rem" color={course.color} margin="0">
            {description[0].content}
          </Section>
          <div
            className="CourseInformation__header"
            style={{ justifyContent: 'flex-end', alignItems: 'flex-end' }}
          >
            <H2 color={course.color2} textAlign="center" margin="0">
              {description[0].title}
            </H2>
            <Figure1 color={course.color2} />
          </div>
        </div>
      </ControlSVG>

      <div className="CourseInformation__flex2" style={{ marginTop: '60px' }}>
        <ControlSVG
          widthText="85%"
          width="600px"
          color={course.color}
          figure={description[1].figure}
        >
          <div className="CourseInformation__header">
            <Figure2 color={course.color2} />
            <H2 color={course.color2} textAlign="center" margin="15px">
              {description[1].title}
            </H2>
          </div>
          <Section fontSize="2rem" color={course.color} margin="0">
            {description[1].content}
          </Section>
        </ControlSVG>
        <ControlSVG
          width="450px"
          color={course.color}
          widthText="70%"
          figure={description[2].figure}
        >
          <div className="CourseInformation__header">
            <Figure3 color={course.color2} />
            <H2 color={course.color2} textAlign="center" margin="0">
              {description[2].title}
            </H2>
          </div>
          <Section fontSize="2rem" color={course.color} margin="0 0 50px">
            {description[2].content}
          </Section>
        </ControlSVG>
      </div>
      <div className="CourseInformation__rectangle">
        <div
          className="CourseInformation__Rborder"
          style={{ border: `7px solid ${course.color}` }}
        >
          <H2 color={course.color2} textAlign="center" margin="0">
            ¿SABÍAS QUÉ?
          </H2>
          <Section fontSize="2rem" color={course.color} margin="0">
            {didYouKnow
              ? didYouKnow
              : 'Al terminar el curso participarás de nuestras ferias nacionales e internacionales de programadores, mostrando el resultado de logros en la web.'}
          </Section>
        </div>
      </div>
    </>
  )
}
function InformationEnglish({ course, description }) {
  return (
    <>
      <div className="CourseInformation__flex" style={{ marginBottom: '40px' }}>
        <div className="CourseInformation__image">
          <img src={course.image} alt="" />
        </div>
        <div className="CourseInformation__section">
          <H2 color={course.color2} textAlign="center" margin="15px">
            {course.section.title}
          </H2>
          <ControlSVG
            color={course.color}
            widthText="70%"
            width="400px"
            figure={course.section.figure}
          >
            <Section fontSize="2rem" color={course.color}>
              {course.section.content}
            </Section>
          </ControlSVG>
        </div>
      </div>
      <ControlSVG
        color={course.color}
        widthText="85%"
        width="800px"
        figure={description[0].figure}
      >
        <div
          className="CourseInformation__header"
          style={{ justifyContent: 'flex-end' }}
        >
          <H2 color={course.color2} textAlign="center" margin="0">
            {description[0].title}
          </H2>
          <Figure1 color={course.color2} />
        </div>
        <Section fontSize="2rem" color={course.color} margin="0">
          {description[0].content}
        </Section>
      </ControlSVG>
      <div className="CourseInformation__flex2" style={{ marginTop: '60px' }}>
        <ControlSVG
          widthText="85%"
          width="600px"
          color={course.color}
          figure={description[1].figure}
        >
          <div className="CourseInformation__header">
            <Figure2 color={course.color2} />
            <H2 color={course.color2} textAlign="center" margin="15px">
              {description[1].title}
            </H2>
          </div>
          <Section fontSize="2rem" color={course.color} margin="0">
            {description[1].content}
          </Section>
        </ControlSVG>
        <ControlSVG
          width="550px"
          color={course.color}
          widthText="80%"
          figure={description[2].figure}
        >
          <div className="CourseInformation__header">
            <Figure3 color={course.color2} />
            <H2 color={course.color2} textAlign="center" margin="15px">
              {description[2].title}
            </H2>
          </div>
          <Section fontSize="2rem" color={course.color} margin="0">
            {description[2].content}
          </Section>
        </ControlSVG>
      </div>
    </>
  )
}
function CardGreen({ children, icon }) {
  return (
    <div className="CardGreen__container">
      <svg
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 465.766 435.731"
        className="CardGreen"
      >
        <g
          id="Group_1"
          data-name="Group 1"
          transform="translate(-199.399 -2754.118)"
        >
          <rect
            id="Rectangle_15"
            data-name="Rectangle 15"
            className="cls-1"
            width="404.259"
            height="367.581"
            rx="19.968"
            transform="translate(202.282 2824.554) rotate(-9.62)"
          />
          <rect
            id="Rectangle_16"
            data-name="Rectangle 16"
            className="cls-2"
            width="376.66"
            height="342.485"
            rx="15.885"
            transform="translate(217.985 2834.619) rotate(-9.62)"
          />
          <rect
            id="Rectangle_14"
            data-name="Rectangle 14"
            className="cls-3"
            width="395.731"
            height="359.152"
            rx="19.968"
            transform="translate(233.488 2790.635) rotate(0.182)"
          />
          <rect
            id="Rectangle_17"
            data-name="Rectangle 17"
            className="cls-4"
            width="348.682"
            height="315.401"
            rx="14.862"
            transform="translate(259.638 2814.017) rotate(0.182)"
          />
        </g>
      </svg>
      <div className="CardGreen__text">
        <i className={`fas fa-${icon}`}></i>
        <p>{children}</p>
      </div>
    </div>
  )
}
function ColorLine() {
  return (
    <div className="ColorLine">
      <div style={{ background: 'var(--purple)' }}></div>
      <div style={{ background: 'var(--orange2)' }}></div>
      <div style={{ background: 'var(--purple)' }}></div>
      <div style={{ background: 'var(--green)' }}></div>
      <div style={{ background: 'var(--purple)' }}></div>
      <div style={{ background: 'var(--orange2)' }}></div>
      <div style={{ background: 'var(--purple)' }}></div>
    </div>
  )
}
function Figure1({ color = 'var(--orange2)' }) {
  const styleFigure = {
    fill: color,
  }
  return (
    <svg viewBox="0 0 106.413 106.765">
      <g
        id="Group_2246"
        data-name="Group 2246"
        transform="translate(-8249 -1487.235)"
      >
        <g
          id="Group_2243"
          data-name="Group 2243"
          transform="translate(8249 1487.235)"
        >
          <path
            id="Path_5433"
            data-name="Path 5433"
            style={styleFigure}
            d="M566.764,433.972a8.367,8.367,0,0,1,.9-.183,43.71,43.71,0,0,0,10.909-5.065,41.3,41.3,0,0,0,14.016-15.549,60.943,60.943,0,0,0,2.908-7.007q.606-2.722,1.213-5.444a47.91,47.91,0,0,0,.422-8.184c-.087-1.94-.405-3.852-.629-5.776a1.046,1.046,0,0,1-.039-.167l-.8-3.422a45.7,45.7,0,0,0-4.925-10.695c1.364,0,2.533-.039,3.7.016a1.885,1.885,0,0,0,1.543-.647q8.841-8.815,17.715-17.6c.27-.268.561-.514.843-.77-.262-.448-.691-.207-1.028-.208-4.9-.019-9.8-.007-14.706-.028-.334,0-.758.245-1.027-.19a38.85,38.85,0,0,1,0-4.6q0-.523,0-1.045a29.973,29.973,0,0,1,0-3.973v-6.846c-.407-.158-.51.138-.662.289q-8.842,8.823-17.68,17.65a5.351,5.351,0,0,0-.935,2.248c.008.522.008,1.05.006,1.6.01.065.016.129.028.194,0,.026.007.039.009.046s0,.012-.006.058a4.392,4.392,0,0,1-.035.573c0,.3,0,.6,0,.915a49.048,49.048,0,0,0-7.9-3.993l-2.946-.983a1.232,1.232,0,0,1-.848-.238,51.383,51.383,0,0,0-8.223-1.219c-.458-.023-.576-.19-.59-.618-.031-.971-.115-1.94-.177-2.911a1.087,1.087,0,0,1-.036-.166l-.743-3.466a28.426,28.426,0,0,0-5.056-9.386l-2.273-2.326a27.739,27.739,0,0,0-9.009-5.264l-4.067-.975a26.855,26.855,0,0,0-10.732.791,28.988,28.988,0,0,0-7.561,3.631,33.453,33.453,0,0,0-5.426,5.221,6.151,6.151,0,0,1-1.055,1.447,29.334,29.334,0,0,0-3.313,7.431,17.67,17.67,0,0,0-.412,2.722v8.155c.159.815.2,1.647.385,2.46.362,1.033.754,2.049,1.193,3.039a30.294,30.294,0,0,0,2.386,4.3,20.256,20.256,0,0,0,1.808,2.246.942.942,0,0,1,.244.389l.071.081a1.879,1.879,0,0,0,.219.213c.031.037.065.071.1.107l1.243,1.168c.248.216.491.438.719.674a27.879,27.879,0,0,0,3.465,2.453c.354.194.406.39.223.733a41.526,41.526,0,0,0-3.663,10.331q-.165.776-.31,1.558c-.018.128-.039.255-.059.383q-.286,2.393-.38,4.8c0,1.356.055,2.714.006,4.069.01.177.025.352.038.528a57.965,57.965,0,0,0,1.019,6.345q.127.526.265,1.05c.319,1.156.695,2.293,1.087,3.426.483,1.271,1.007,2.519,1.586,3.74l.026.056.006.011a52.025,52.025,0,0,0,2.727,4.847q.338.509.694,1.009.952,1.209,1.856,2.451.476.561.965,1.107a48.831,48.831,0,0,0,6.486,5.941h0l2.322,1.594a45.9,45.9,0,0,0,8.782,4.117c.488.161.967.348,1.45.524,1.568.355,3.162.627,4.689,1.11.507.161,1.129-.247,1.526.273.107.007.213.019.321.024h9.4C562.928,434.737,564.89,434.566,566.764,433.972Zm19.387-77.345c1.794-1.573,3.4-3.359,5.088-5.054l.289.086v7.872h7.815c-1.527,1.56-3.088,2.943-4.387,4.54a5.392,5.392,0,0,1-5.332,2.163,21.8,21.8,0,0,0-2.923-.023,1.72,1.72,0,0,1-1.933-1.973c.006-1.287.031-2.574.048-3.862A3.63,3.63,0,0,1,586.151,356.627Zm-29.085,3.756c.12-.476.448-.443.8-.413a26.169,26.169,0,0,1,3.939.444,14.71,14.71,0,0,1,3.58.787,29.144,29.144,0,0,1,10.045,4.547,9.368,9.368,0,0,1,2.295,1.671c.636.249.8.517.207,1.074-1.19,1.114-2.33,2.284-3.461,3.46-.384.4-.664.432-.971-.037l-2.512-1.7a31.093,31.093,0,0,0-10.85-3.795l-4.392-.223h-1.09A25.279,25.279,0,0,0,557.066,360.383Zm-3.409,12.344a20.1,20.1,0,0,1,9.995.983,10.819,10.819,0,0,1,2.549,1.119,9.944,9.944,0,0,1,2.734,1.642c.362.152.751.266.26.748-1.278,1.253-2.536,2.527-3.8,3.794-.2.2-.4.433-.657.073l-2.938-1.431a15.716,15.716,0,0,0-20.387,19.173c.055.2.092.4.137.607l1.4,2.98a16.679,16.679,0,0,0,7.988,6.7h0l3.14.825a16.563,16.563,0,0,0,8.748-1.245,15.574,15.574,0,0,0,9.226-15.21c-.017-.345-.014-.692-.021-1.038a.832.832,0,0,1-.051-.206,26.452,26.452,0,0,0-.912-3.432c-.4-.8-.765-1.623-1.211-2.4-.261-.453-.292-.736.125-1.13,1.206-1.142,2.37-2.327,3.529-3.517.349-.358.551-.5.88.046a17.659,17.659,0,0,1,1.5,2.587,9.665,9.665,0,0,1,1.178,2.744,20.627,20.627,0,0,1-.212,15.054,19.944,19.944,0,0,1-5.148,7.923,20.953,20.953,0,0,1-6.326,4.292c-.336.148-.642.433-1.061.309h0a12.467,12.467,0,0,1-4.836,1.38,20.41,20.41,0,0,1-10.012-.961,12.159,12.159,0,0,1-3.339-1.445,19.9,19.9,0,0,1-7.54-6.67,9.8,9.8,0,0,1-1.652-2.74,20.707,20.707,0,0,1-2.283-12.128,18.4,18.4,0,0,1,1.64-6.276,21.09,21.09,0,0,1,11.429-11.533A16.486,16.486,0,0,1,553.657,372.727Zm1.067,19.987c1.162,1.1,2.3,2.22,3.387,3.393.481.521.72.373,1.131-.048,1.844-1.887,3.72-3.743,5.663-5.689a7.948,7.948,0,0,1,.865,4.089h0a9.36,9.36,0,0,1-9.495,9.345,1.532,1.532,0,0,1-.389-.119,8.994,8.994,0,0,1-8.105-5.828,7.028,7.028,0,0,1-.635-3.826,9.126,9.126,0,0,1,7.705-8.8,7.5,7.5,0,0,1,4.876.446c.652.069.785.252.255.77-1.764,1.725-3.484,3.5-5.251,5.218C554.312,392.069,554.282,392.3,554.723,392.714Zm-36-26.685a17.079,17.079,0,0,1-4.6-10.248,10.582,10.582,0,0,1,0-4.214,19.1,19.1,0,0,1,16.714-16.715,10.594,10.594,0,0,1,4.215,0,17.083,17.083,0,0,1,10.249,4.6,9.463,9.463,0,0,1,2.06,2.116,17.563,17.563,0,0,1,4.235,10.645,11.2,11.2,0,0,1-.216,4.659,16.9,16.9,0,0,1-3.844,8.6,18.623,18.623,0,0,1-10.774,6.6,3.779,3.779,0,0,1-.62.036,11.278,11.278,0,0,1-4.657.213,17.554,17.554,0,0,1-10.646-4.232A9.477,9.477,0,0,1,518.721,366.029ZM550.1,428.422a1.669,1.669,0,0,1-.286-.061,29.707,29.707,0,0,1-10.179-3.77,14.171,14.171,0,0,1-2.716-1.692,30.377,30.377,0,0,1-7.323-6.872,14.282,14.282,0,0,1-1.854-2.547,29.394,29.394,0,0,1-4.417-9.793.948.948,0,0,1-.079-.233,12.041,12.041,0,0,1-.737-3.56,30.645,30.645,0,0,1-.133-10.68,22.75,22.75,0,0,1,1.343-5.431,26.835,26.835,0,0,1,2.248-5.467.569.569,0,0,1,.731-.373c.8.185,1.6.36,2.4.538a.626.626,0,0,1,.329.073l3.525.226a30.658,30.658,0,0,0-2.723,5.22,27.215,27.215,0,0,0-1.93,8.9c-.022.519-.094,1.035-.143,1.553q.182,1.987.364,3.973a30.1,30.1,0,0,0,3.585,10.27l1.828,2.706a30.957,30.957,0,0,0,7.586,6.937l2.939,1.621a31.984,31.984,0,0,0,11.707,2.7l4.386-.357a28.069,28.069,0,0,0,17.145-9.442,27.243,27.243,0,0,0,6.52-13.839,4.789,4.789,0,0,1,.173-.6l.243-4.808a30.515,30.515,0,0,0-2.76-11.5l-1.414-2.519c-.539-.759-1.044-1.546-1.63-2.267-.356-.437-.24-.674.111-1.014,1.167-1.131,2.322-2.275,3.444-3.451.433-.454.679-.429,1.01.089.443.695.948,1.349,1.426,2.02a13.144,13.144,0,0,1,1.684,2.739,29.857,29.857,0,0,1,3.76,10.417,1.006,1.006,0,0,1,.081.391,20.9,20.9,0,0,1,.492,4.885,34.4,34.4,0,0,1-4.2,17.678,5.047,5.047,0,0,1-.569.723,16.718,16.718,0,0,1-2.943,4.47,33.1,33.1,0,0,1-9.052,7.865c-.169.1-.312.3-.555.192a11.8,11.8,0,0,1-3.609,1.952,32.883,32.883,0,0,1-15.831,2.635A16.321,16.321,0,0,1,550.1,428.422Z"
            transform="translate(-508.128 -328.411)"
          />
          <path
            id="Path_5434"
            data-name="Path 5434"
            style={styleFigure}
            d="M545.489,381.86a17.389,17.389,0,0,0-2.13-2.128c-1.069-1.094-2.117-2.209-3.217-3.271-.427-.412-.43-.652,0-1.061q1.742-1.657,3.4-3.4c.414-.436.654-.414,1.061.007,1.063,1.1,2.177,2.147,3.271,3.216.489.525.646-.1.844-.293,2.992-2.961,5.988-5.921,8.925-8.937.639-.656,1.026-.744,1.588,0a8.467,8.467,0,0,0,1.049,1c.7.724,1.381,1.464,2.1,2.163.358.346.46.557.04.974q-6.924,6.87-13.8,13.79c-.44.443-.667.378-1.053-.034C546.912,383.183,546.187,382.534,545.489,381.86Z"
            transform="translate(-526.106 -349.432)"
          />
        </g>
      </g>
    </svg>
  )
}
function Figure2({ color = 'var(--orange2)' }) {
  const styleFigure = {
    fill: color,
    stroke: color,
  }
  return (
    <svg viewBox="0 0 83.22 97.508">
      <g
        id="Group_2242"
        data-name="Group 2242"
        transform="translate(-514.729 -51.241)"
      >
        <path
          id="Path_5429"
          data-name="Path 5429"
          style={styleFigure}
          d="M596.536,131.348q-6.52-11.438-13.047-22.873c-.414-.722-.635-1.177.211-1.827a3.746,3.746,0,0,0,1.3-3.655c-.313-2.453-.6-4.909-.942-7.358a1.87,1.87,0,0,1,.579-1.745c1.68-1.688,3.3-3.432,4.951-5.152,1.889-1.973,1.94-4.068.114-6.071-1.573-1.726-3.154-3.446-4.772-5.129a2.233,2.233,0,0,1-.716-2.106c.382-2.3.643-4.619.967-6.929.416-2.966-.772-4.594-3.735-5.147-2.293-.428-4.573-.927-6.87-1.326a1.869,1.869,0,0,1-1.481-1.084c-1.107-2.107-2.265-4.188-3.395-6.284-1.454-2.7-3.237-3.307-6.028-2.025-1.993.915-4,1.813-5.954,2.8a2.583,2.583,0,0,1-2.616-.056c-2.066-1.082-4.176-2.081-6.286-3.076-2.34-1.1-4.166-.523-5.436,1.717-1.22,2.152-2.432,4.311-3.591,6.5a2,2,0,0,1-1.616,1.13c-2.485.4-4.971.824-7.438,1.324a3.875,3.875,0,0,0-3.273,4.6c.313,2.453.595,4.91.946,7.358a2.007,2.007,0,0,1-.629,1.87c-1.674,1.694-3.3,3.435-4.948,5.155a3.987,3.987,0,0,0-.1,5.967c1.606,1.759,3.214,3.518,4.867,5.233a2.108,2.108,0,0,1,.665,1.988c-.4,2.487-.7,4.99-1.057,7.483a3.529,3.529,0,0,0,1.491,3.68c.878.587.732,1.013.3,1.77q-6.646,11.688-13.231,23.411c-1.149,2.038-.389,3.388,1.909,3.391,4.345.007,8.69.049,13.034-.028a2.329,2.329,0,0,1,2.391,1.425c1.862,3.4,3.835,6.735,5.766,10.094,1.269,2.208,2.733,2.21,4.028,0q6.164-10.512,12.324-21.026c.267-.456.564-.895.922-1.461.29.458.47.723.63,1q6.21,10.728,12.421,21.455c.507.874.922,1.887,2.192,1.916,1.307.029,1.684-1.018,2.18-1.893,1.955-3.453,3.912-6.906,5.807-10.393a1.814,1.814,0,0,1,1.854-1.108c4.111.049,8.223-.032,12.333.049,1.558.031,2.942-.077,3.891-1.49v-.561C597.144,132.352,596.827,131.857,596.536,131.348Zm-43-10.927c-4.139,7.2-8.264,14.4-12.547,21.87-1.918-3.3-3.742-6.34-5.451-9.441a2.992,2.992,0,0,0-3.034-1.725c-3.641.08-7.285.013-10.927.036-.872.006-1.35.019-.723-1.077q6.084-10.632,12.059-21.327c.423-.755.886-.771,1.677-.762,3.351.038,5.37,1.671,6.48,4.763a26.245,26.245,0,0,0,1.9,3.579,3.821,3.821,0,0,0,5.314,1.874c.988-.416,1.959-.877,2.919-1.356.514-.257.844-.216,1.121.334.356.708.762,1.393,1.176,2.069A1.009,1.009,0,0,1,553.532,120.421Zm.524-9.066c-2.169,1.087-4.4,2.058-6.57,3.133-.77.381-1.182.359-1.6-.505-1.044-2.137-2.244-4.2-3.312-6.324a4.419,4.419,0,0,0-3.557-2.58c-2.442-.365-4.856-.918-7.294-1.321-.805-.133-.947-.414-.818-1.2.407-2.485.669-4.994,1.066-7.481a4.057,4.057,0,0,0-1.068-3.6c-1.549-1.684-3.013-3.457-4.661-5.037-1.082-1.036-.829-1.67.1-2.566,1.513-1.456,2.879-3.064,4.388-4.524a4.42,4.42,0,0,0,1.413-4.038c-.32-2.358-.553-4.728-.875-7.086-.139-1.018.086-1.479,1.233-1.626,2.357-.3,4.681-.844,7.03-1.216a4.213,4.213,0,0,0,3.276-2.324c1.166-2.181,2.421-4.315,3.586-6.5.362-.677.685-.809,1.391-.445,2.157,1.109,4.367,2.115,6.529,3.215a4.351,4.351,0,0,0,4.15.056c2.181-1.062,4.42-2.006,6.6-3.065.795-.386,1.2-.323,1.614.524,1.074,2.175,2.276,4.286,3.39,6.442a4.155,4.155,0,0,0,3.208,2.4c2.436.405,4.842.985,7.271,1.438.715.134,1.159.339.946,1.036-.348,2.48-.617,4.847-1.031,7.188a4.668,4.668,0,0,0,1.346,4.46c1.648,1.651,3.172,3.426,4.788,5.112.567.592.6.984-.02,1.6-1.7,1.667-3.3,3.436-4.984,5.118a4.374,4.374,0,0,0-1.353,4.168c.417,2.387.56,4.82.919,7.219.155,1.034-.509,1.047-1.128,1.154-2.344.407-4.689.81-7.04,1.167a4.1,4.1,0,0,0-3.182,2.236c-1.178,2.175-2.427,4.312-3.581,6.5-.389.737-.738.9-1.5.5-2.114-1.091-4.29-2.063-6.4-3.166A4.353,4.353,0,0,0,554.056,111.354Zm36.523,19.8c-3.6,0-7.192.062-10.785-.028a2.941,2.941,0,0,0-2.986,1.788c-1.7,3.161-3.5,6.267-5.41,9.661-2.181-3.766-4.214-7.267-6.236-10.775q-4.508-7.821-8.989-15.658c-.222-.389-.854-.833-.319-1.325.413-.38.866.1,1.264.295,2.188,1.049,4.357,2.136,6.55,3.173a3.867,3.867,0,0,0,5.56-1.76c1.192-2.113,2.389-4.224,3.518-6.37a1.969,1.969,0,0,1,1.709-1.193,18.26,18.26,0,0,0,3.3-.591,1.365,1.365,0,0,1,1.878.8c3.881,6.918,7.816,13.8,11.731,20.7C592.083,131.137,592.073,131.148,590.579,131.15Z"
        />
        <path
          id="Path_5430"
          data-name="Path 5430"
          style={styleFigure}
          d="M612.66,110.217a19.053,19.053,0,1,0-18.979,19.211A19.02,19.02,0,0,0,612.66,110.217Zm-34.362.071a15.271,15.271,0,1,1,15.21,15.315A15.425,15.425,0,0,1,578.3,110.288Z"
          transform="translate(-37.453 -24.981)"
        />
      </g>
    </svg>
  )
}
function Figure3({ color = 'var(--orange2)' }) {
  const styleFigure = {
    fill: color,
  }
  return (
    <svg viewBox="0 0 76.571 79.07">
      <g
        id="Group_2247"
        data-name="Group 2247"
        transform="translate(-1136.357 -1597.869)"
      >
        <g
          id="Group_2245"
          data-name="Group 2245"
          transform="translate(601.872 941.824)"
        >
          <path
            id="Path_5435"
            data-name="Path 5435"
            style={styleFigure}
            d="M708.04,688.576c.193-1.007.4-2.38.735-3.721a1.8,1.8,0,0,1,3.513.618,21.621,21.621,0,0,1-.713,4.167,1.755,1.755,0,0,1-2.04,1.241C708.6,690.711,708.028,689.972,708.04,688.576Z"
            transform="translate(-116.35 -18.461)"
          />
          <path
            id="Path_5436"
            data-name="Path 5436"
            style={styleFigure}
            d="M734.152,698.5a1.893,1.893,0,0,1,1.824.952,1.691,1.691,0,0,1-.042,1.822,3.578,3.578,0,0,1-.476.6c-1.175,1.186-2.352,2.372-3.542,3.544a1.916,1.916,0,0,1-2.855.215,1.888,1.888,0,0,1,.2-2.794c1.186-1.212,2.393-2.4,3.595-3.6A2.063,2.063,0,0,1,734.152,698.5Z"
            transform="translate(-130.088 -28.463)"
          />
          <path
            id="Path_5437"
            data-name="Path 5437"
            style={styleFigure}
            d="M749.677,729.329a1.994,1.994,0,0,1,2.189,1.518,1.771,1.771,0,0,1-1.335,2.055,38.343,38.343,0,0,1-4.015.709,1.808,1.808,0,0,1-.678-3.529C747.2,729.739,748.6,729.534,749.677,729.329Z"
            transform="translate(-140.837 -49.129)"
          />
          <path
            id="Path_5438"
            data-name="Path 5438"
            style={styleFigure}
            d="M643.154,766.942q0-7.263,0-14.526a2.477,2.477,0,0,1,2.292-1.963,2.364,2.364,0,0,1,2.337,1.331,3.054,3.054,0,0,1,.3,1.5c.011.949.027,1.9.04,2.847a21.378,21.378,0,0,0,0,2.935v3.615c1.486-.643,2.913-1.263,4.343-1.879a2.59,2.59,0,0,1,3.705,1.044c.452,1.773-.025,2.742-1.7,3.48-1.091.481-2.177.973-3.265,1.46-1.409.593-2.821,1.18-4.227,1.782C645.137,769.348,643.839,768.8,643.154,766.942Z"
            transform="translate(-72.848 -63.285)"
          />
          <path
            id="Path_5439"
            data-name="Path 5439"
            style={styleFigure}
            d="M568.639,837.648l8.766-11.583a2.477,2.477,0,0,0-.644-2.948,2.363,2.363,0,0,0-2.666-.348,3.051,3.051,0,0,0-1.138,1.014q-.872,1.125-1.75,2.246a21.307,21.307,0,0,1-1.771,2.341l-2.181,2.884c-.8-1.409-1.561-2.765-2.33-4.119a2.591,2.591,0,0,0-3.585-1.4c-1.43,1.142-1.635,2.2-.744,3.8.58,1.042,1.149,2.09,1.724,3.135.766,1.323,1.538,2.643,2.3,3.971C565.605,838.371,566.97,838.718,568.639,837.648Z"
            transform="translate(-17.146 -111.598)"
          />
          <g
            id="Group_2244"
            data-name="Group 2244"
            transform="translate(534.485 656.045)"
          >
            {/* <path
              id="Path_5440"
              data-name="Path 5440"
              style={styleFigure}
              d="M649.676,724.557l.3.032c.06,0,.119.006.177.006C649.994,724.578,649.835,724.562,649.676,724.557Z"
              transform="translate(-611.708 -701.975)"
            /> */}
            {/* <path
              id="Path_5441"
              data-name="Path 5441"
              style={styleFigure}
              d="M639.588,789.558a.391.391,0,0,1,.058-.021c-.005-.015-.01-.03-.015-.045C639.616,789.512,639.6,789.536,639.588,789.558Z"
              transform="translate(-604.945 -745.506)"
            /> */}
            <path
              id="Path_5442"
              data-name="Path 5442"
              style={styleFigure}
              d="M575.385,735.036c.961-.16,1.923-.316,2.879-.5a31.561,31.561,0,0,0,12.7-5.445,32.876,32.876,0,0,0,12.523-17.27,38.8,38.8,0,0,0,1.193-5.409l.27-3.24a42.157,42.157,0,0,0-1.085-9.374c-.013-.033-.023-.066-.031-.1L603,691.118a40.088,40.088,0,0,0-3.657-7.237,10.831,10.831,0,0,1-1.212-1.705,46.1,46.1,0,0,0-5.233-5.384l-1.861-1.419a39.14,39.14,0,0,0-6.927-3.748l-2.491-.892c-.7-.021-1.067-.312-.967-1.087.065-.506-.123-1.088.064-1.523.194-.452.861-.29,1.306-.452a5.96,5.96,0,0,0,2.595-9.517c-.165-.2-.333-.389-.5-.584a11.007,11.007,0,0,0-1.932-1.185,13.008,13.008,0,0,0-3.663-.34c-4.805.01-9.611-.006-14.416.008a5.849,5.849,0,0,0-5.971,4.576,6.106,6.106,0,0,0,.95,4.984,9.744,9.744,0,0,0,1.714,1.551,6.508,6.508,0,0,0,2.093.725c.427.044.5.259.466.61a.077.077,0,0,0,0,.012,1.681,1.681,0,0,1,0,.986c-.043.989-.332,1.075-1.78,1.542a33.963,33.963,0,0,0-10.412,5.7,46.659,46.659,0,0,0-5.2,5.3,43.278,43.278,0,0,0-3.673,6.044,32.932,32.932,0,0,0-2.989,10.465c-.034.305-.1.606-.157.909l-.01.31-.012,4.479a3.173,3.173,0,0,1-.864,3.169,16.383,16.383,0,0,0-3.774,10.122,1.741,1.741,0,0,1,0,.215,30.037,30.037,0,0,0,.21,3.168,18.942,18.942,0,0,0,3.223,7.405l1.493,1.732a19.244,19.244,0,0,0,6.682,4.177,28.061,28.061,0,0,0,3.341.734c.122.016.279-.019.347.119l.159.021H551.1a.677.677,0,0,1,.643-.089,1.248,1.248,0,0,1,.361.089h.841c.394-.29.883-.146,1.318-.228a16.575,16.575,0,0,0,5.08-1.715,1.3,1.3,0,0,1,1.432,0l2.687.873c1.774.383,3.552.741,5.355.967.035,0,.066.044.1.085l.185.02h.647c.048-.147.175-.108.293-.09h.616a.332.332,0,0,1,.216.012.288.288,0,0,1,.236.079h2.357a.265.265,0,0,1,.3-.091h0a.343.343,0,0,1,.222.012.266.266,0,0,1,.214.078h.618A5.47,5.47,0,0,1,575.385,735.036Zm-12.464-73.073a.922.922,0,0,1,1.045-.966c.894-.005,1.788.013,2.682.02h10.965a9.579,9.579,0,0,1,2.935.131c.535.219.578.661.5,1.14a.8.8,0,0,1-.906.738c-1.458.142-2.92.042-4.38.05-3.647.02-7.294.012-10.94.009-.33,0-.659-.044-.989-.068C563.126,663.014,562.9,662.574,562.921,661.964Zm5.463,6.139a22.574,22.574,0,0,1,3.723-.071,19.537,19.537,0,0,1,3.493.072c.243.367.1.775.107,1.162.009.325-.274.231-.456.221-.911-.052-1.821-.116-2.731-.177h-1.236l-1.63.046h0a1.524,1.524,0,0,1-.841.108c-.293.066-.563.094-.514-.345C568.336,668.781,568.205,668.428,568.384,668.1Zm-4.974,52.389c-.639,4.505-5.336,9.068-9.7,9.428a7.626,7.626,0,0,1-3.28.139,11.24,11.24,0,0,1-7.436-3.516,6.92,6.92,0,0,1-1.429-1.714,11.6,11.6,0,0,1-1.924-8.835,12.042,12.042,0,0,1,9.708-9.865,11.592,11.592,0,0,1,8.958,1.842,7.448,7.448,0,0,1,1.857,1.536,11.221,11.221,0,0,1,3.413,7.071.544.544,0,0,1,.043.265A8.767,8.767,0,0,1,563.41,720.492Zm27.982-14.165a18.684,18.684,0,0,1-4.176,8.64,19.808,19.808,0,0,1-11.072,6.7,3.624,3.624,0,0,1-.534.044,10.489,10.489,0,0,1-3.245.322,15.132,15.132,0,0,1-3.751-.242c-.3-.047-.358-.176-.3-.468a18.53,18.53,0,0,0,.173-5.91,1.078,1.078,0,0,1-.061-.243l-.685-2.727a19.229,19.229,0,0,0-4.038-6.469l-1.821-1.573a18.851,18.851,0,0,0-7.442-3.231c-.532-.05-1.063-.134-1.595-.138-.477,0-.721-.112-.588-.65.078-.316-.014-.664.155-.969a17.333,17.333,0,0,1,2.556-7.345,19.684,19.684,0,0,1,13.417-9.361,9.835,9.835,0,0,1,.993-.1.789.789,0,0,1,.356-.061,10.181,10.181,0,0,1,3.246-.079,17.937,17.937,0,0,1,8.5,2.349,10.021,10.021,0,0,1,2.073,1.338,17.163,17.163,0,0,1,5.226,5.574,6.155,6.155,0,0,1,1.04,1.868,17.924,17.924,0,0,1,2,8.961A13.083,13.083,0,0,1,591.393,706.327Zm-23.511,23.542a13.506,13.506,0,0,1-2.777-.6c-.35,0-.695-.009-.3-.481a15.932,15.932,0,0,0,2.058-3.209.408.408,0,0,1,.533-.275c.418.106.843.184,1.265.274a31.411,31.411,0,0,0,3.361.191,3.962,3.962,0,0,1,1.583-.016q14.114-1.428,20.072-14.3a22.189,22.189,0,0,0,1.892-8.59,2.682,2.682,0,0,1-.01-.68q-.033-1.664-.2-3.321a27.129,27.129,0,0,0-2.781-8.191l-1.182-1.867a27.246,27.246,0,0,0-5.269-5.44l-2-1.36a27.361,27.361,0,0,0-7.581-2.943l-3.785-.4c-.1-.006-.2-.015-.3-.032h0a24.822,24.822,0,0,0-12.3,3.221,25.425,25.425,0,0,0-8.456,8.4,28.008,28.008,0,0,0-2.39,5.806,21.5,21.5,0,0,0-.738,4.469c-.02.509-.167.757-.724.859a13.233,13.233,0,0,0-3.27,1.091c-.335.159-.565.253-.543-.284a26.073,26.073,0,0,1,.543-5.2,17.384,17.384,0,0,1,1.219-4.33,22.384,22.384,0,0,1,3.185-6.266,27.924,27.924,0,0,1,11.885-9.808,5.081,5.081,0,0,1,1.294-.459,18.911,18.911,0,0,1,4.8-1.363,26.1,26.1,0,0,1,10.67.117,12.9,12.9,0,0,1,2.473.63,24.229,24.229,0,0,1,7.252,3.406,10.03,10.03,0,0,1,1.882,1.375,22.846,22.846,0,0,1,5.233,5.405,8.293,8.293,0,0,1,1.366,2.024,22.675,22.675,0,0,1,3.132,7.355h0a9.028,9.028,0,0,1,.579,2.688,25.2,25.2,0,0,1,.1,8.544,12.316,12.316,0,0,1-.676,3.049,18.114,18.114,0,0,1-1.881,5.085,25.116,25.116,0,0,1-5.4,7.616,26.428,26.428,0,0,1-7.435,5.279,2.434,2.434,0,0,1-.287.095h0a18.718,18.718,0,0,1-4.957,1.819A26.091,26.091,0,0,1,567.881,729.869Z"
              transform="translate(-534.485 -656.045)"
            />
          </g>
        </g>
      </g>
    </svg>
  )
}
export default withRouter(CourseInformation)
